import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { EndpointsIntegrations } from '../integrations-flow/EndpointsIntegrations';
import { EndpointsStandaloneCmsPartner } from './EndpointsStandaloneCmsPartner';
import { EndpointsUserOnlyFlow } from './http-user-only-signup/EndpointsUserOnlyFlow';
export const getFlowEndpointOverrides = () => {
  switch (getFlowKey()) {
    case Flow.Integrations:
      return EndpointsIntegrations;

    case Flow.StandaloneCmsPartner:
      return EndpointsStandaloneCmsPartner;

    case Flow.Connect:
    case Flow.ChatSpot:
      return EndpointsUserOnlyFlow;

    default:
      return {};
  }
};